import React from 'react';
import { StaticQuery } from "gatsby"
import './styles.scss'

const FeatureList = ({features, iconMap}) => {
  return <div className="container-fluid features-list p-0">
    <div className="row justify-content-between">
      {
        features.map(col => {
          const icon = iconMap[col.key]
          return <div className="feature-item col-12 col-md-6 col-xl-4 mb-5" key={col.key}>
            <div className="row align-items-center">
              <div className="col-2 col-xl-3">
                <div className="feature-icon ml-auto mx-md-auto">
                  <img src={icon.publicURL} loading="lazy" decoding="async" alt={col.alt || icon.name}/>
                </div>
              </div>
              <div className="feature-title col-10 col-xl-9 pl-lg-0 d-flex d-md-block align-items-center">
                { col.label && <div className="feature-title-label order-2 ml-4 ml-md-0 mb-md-2">{col.label}</div>}
                <h5 className="mb-0 order-1">{col.title}</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-2 col-md-0"></div>
              <div className="feature-description col-10 col-md-12">{col.description}</div>
            </div>
          </div>
        })
      }
    </div>
  </div>
}

export default FeatureList
